import axios from "axios"
export function searchUserData(token, keyword) {
    return axios.get(process.env.REACT_APP_API_URL + `/searchUserData?keyword=${keyword}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}